import * as api from "../../shared/api";
import apiPath from "../../shared/apiPath";
import * as biz_data_helper from "../../shared/biz_data_helper";

const content_type = "";

const create = function () {
  return {
    content_type: "muji"
  };
};
const fields = [
  {
    key: "id",
    label: "编号",
    type: "button",
    button: { type: "text" },
    thStyle: { width: "60px" }
    // isRowHeader:true,
  },
  {
    key: "name",
    label: "权限名称",
    sortable: true
  },
  {
    key: "code",
    label: "权限编码",
    sortable: true
  },
  {
    key: "category",
    label: "权限类别"
  },
  {
    key: "description",
    label: "备注",
    sortable: true
  },
  {
    key: "is_valid",
    label: "状态",
    type: "boolean"
  }
];

const dataForm = {
  id: 0,
  name: "",
  category: "",
  description: "",
  is_valid: false
};

///前端验证
const rules = {
  name: [{ required: true, message: "请输入权限名称", trigger: "blur" }]
};

const descriptor = {};

const methods = {
  ///get
  async getData() {
    let result = await api.query_async({
      url: apiPath.admin.get_privilege_list,
      parameters: null,
      method: "get"
    });
    ///此处可以编写逻辑处理
    if (
      result &&
      result[0].result.data &&
      result[0].result.data.Result.length > 0
    ) {
      return result[0].result.data.Result;
    } else {
      return null;
    }
  },
  ///update
  async upData(_data) {
    let datas = _data.selected_items;

    switch (_data.state) {
      case "valid":
        //启用
        for (var i in datas) {
          datas[i].is_valid = true;
        }
        break;
      case "invalid":
        for (var i in datas) {
          datas[i].is_valid = false;
        }
        //禁用
        break;
      default:
        break;
    }
    let query_settings = [];

    // 修改操作
    for (var i in datas) {
      let _p = new FormData();
      _p.append("privilegeId", datas[i].id);
      _p.append("name", datas[i].name);
      _p.append(
        "description",
        _.isNull(datas[i].description) ? "" : datas[i].description
      );
      _p.append(
        "category",
        _.isNull(datas[i].category) ? "" : datas[i].category
      );
      _p.append("is_valid", datas[i].is_valid);
      query_settings.push({
        url: apiPath.admin.update_privileges,
        parameters: _p,
        method: "post"
      });
    }
    let result = await api.query_all_async(query_settings);
    if (result && result[0].result && result[0].result.data) {
      return result[0].result.data;
    } else {
      return null;
    }
  }
};

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
);
export { fields, dataForm, methods, rules, biz_data };
